module.exports = "/_next/static/images/elf_rose-f2f30eb09be1060ae65807629c21d1e8.png";